<template>
  <div>
    <v-card-actions>
      <v-card-title>DETAIL DESCRIPTION</v-card-title>
      <v-btn
        fab
        small
        color="primary"
        @click="addDetail = true"
        v-b-tooltip.hover
        title="Click to add project description in different language"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-actions>
    <v-tabs v-model="tabs" background-color="transparent" grow>
      <v-tab
        v-for="description in getProjectTranslations"
        :key="description.id"
      >
        {{ description.language_name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item
        v-for="description in getProjectTranslations"
        :key="description.id"
      >
        <v-container>
          <v-btn
            v-if="!editDetail"
            color="info"
            fab
            small
            @click="
              clickedEditDescription(description.project_detail_description)
            "
            ><v-icon>mdi-pencil</v-icon></v-btn
          >
          <div v-else>
            <v-btn
              color="success"
              fab
              small
              @click="updateDescription(description.id)"
            >
              <v-icon>mdi-check</v-icon></v-btn
            >
            <v-btn color="secondary" fab small @click="clearDescription">
              <v-icon>mdi-close</v-icon></v-btn
            >
          </div>
          <vue-editor
            v-if="editDetail"
            v-model="detail.description"
            :editorToolbar="customToolbar"
          ></vue-editor>
          <div v-else class="text_box">
            <p v-html="description.project_detail_description"></p>
          </div>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <v-card-title>BUDGET</v-card-title>
    <v-card-actions>
      <v-text-field
        outlined
        v-if="editBudget"
        v-model="projectBudget"
      ></v-text-field>
      <div v-else class="text_box">{{ getBudget }}</div>
      <v-btn
        v-if="!editBudget"
        fab
        small
        color="info"
        v-b-tooltip.hover
        title="Click to edit Project Budget"
        @click="clickedEditBudget(getBudget)"
        ><v-icon>mdi-pencil</v-icon></v-btn
      >
      <div v-else>
        <v-btn fab small color="success" @click="changeProjectBudget">
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn fab small color="secondary" @click="editBudget = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
    </v-card-actions>
    <v-card-title>URL</v-card-title>
    <v-card-actions>
      <v-text-field v-if="editUrl" outlined v-model="projectUrl"></v-text-field>
      <div v-else class="text_box">{{ getUrl }}</div>
      <v-btn
        v-if="!editUrl"
        fab
        small
        color="info"
        @click="clickedEditUrl(getUrl)"
        ><v-icon>mdi-pencil</v-icon></v-btn
      >
      <div v-else>
        <v-btn fab small color="success" @click="changeProjectUrl"
          ><v-icon>mdi-check</v-icon></v-btn
        >
        <v-btn fab small color="secondary" @click="editUrl = false"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-card-actions>
    <project-description-add
      :add-detail="addDetail"
      :languages="languages"
      @add-description-model-update="updateProjectDetailAddProp"
    ></project-description-add>
  </div>
</template>
<script>
import {VueEditor} from "vue2-editor";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
import ProjectDescriptionAdd from "@/components/Projects/ProjectInnerCardsComp/ProjectDescriptionAdd";
import {mapActions, mapGetters} from "vuex";
export default {
  name: "ProjectDescription",
  components: {
    "project-description-add": ProjectDescriptionAdd,
    "vue-editor": VueEditor,
  },
  props: ["languages", "budget", "url"],
  data() {
    return {
      detail: {
        language: "",
        description: "",
      },
      projectBudget: "",
      projectUrl: "",
      editUrl: false,
      editBudget: false,
      editDetail: false,
      addDetail: false,
      tabs: null,
      timeout: 3000,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        ["link", "code-block"],
      ],
    };
  },
  computed: {
    ...mapGetters(["getProjectTranslations"]),
    getUrl() {
      if (this.url === "") return "No Url";
      return this.url;
    },
    getBudget() {
      if (this.budget === "") return "No Budget";
      return this.budget;
    },
  },
  methods: {
    ...mapActions([
      "CreateProjectTranslation",
      "UpdateProjectDetailDescription",
      "UpdateProjectBudget",
      "UpdateProjectUrl",
      "showLoadingProcess",
      "closeLoading",
      "showSnackBar",
      "closeSnackBar",
    ]),
    clickedEditUrl(url) {
      this.editUrl = true;
      this.projectUrl = url;
    },
    clickedEditBudget(budget) {
      this.editBudget = true;
      this.projectBudget = budget;
    },
    clickedEditDescription(description) {
      this.editDetail = true;
      this.detail.description = description;
    },
    async updateDescription(id) {
      await this.showLoadingProcess();
      try {
        const data = {
          id: id,
          project_detail_description: this.detail.description,
        };
        await this.UpdateProjectDetailDescription(data);
        await this.closeLoading();
        await this.showSnackBar({
          text: "Description has been Updated",
          color: DEFAULT_CONSTANTS.success,
        });
        this.clearDescription();
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        await this.closeLoading();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        this.clearDescription();
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
    async changeProjectBudget() {
      await this.showLoadingProcess();
      try {
        const data = {
          id: this.$route.query.project_id,
          project_budget: this.projectBudget,
        };
        await this.UpdateProjectBudget(data);
        await this.closeLoading();
        this.clearBudget();
        await this.showSnackBar({
          text: "Budget has been Updated",
          color: DEFAULT_CONSTANTS.success,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        await this.closeLoading();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        this.clearBudget();
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
    async changeProjectUrl() {
      await this.showLoadingProcess();
      try {
        const data = {
          id: this.$route.query.project_id,
          project_catch_copy: this.projectUrl,
        };
        await this.UpdateProjectUrl(data);
        await this.showSnackBar({
          text: "Url has be Updated",
          color: DEFAULT_CONSTANTS.success,
        });
        await this.closeLoading();
        this.clearUrl();
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        console.log(err);
        await this.closeLoading();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
    updateProjectDetailAddProp(value) {
      this.addDetail = value;
    },
    clearDescription() {
      this.detial = {};
      this.editDetail = false;
    },
    clearBudget() {
      this.projectBudget = "";
      this.editBudget = false;
    },
    clearUrl() {
      this.editUrl = false;
      this.projectUrl = "";
    },
  },
};
</script>
<style scoped>
.text_box {
  background-color: whitesmoke;
  padding: 10px;
  text-align: justify;
  border: 3px solid;
  border-radius: 5px;
}
</style>
